<template>
  <div class="dags-container">
    <h1 class="text-title">Dags att vara långt ifrån smärtstillande medel</h1>
    <div class="image-section">
      <img src="@/assets/dags/dags1.jpg" alt="Dags 1" class="dags-image">
      <img src="@/assets/dags/dags2.jpg" alt="Dags 2" class="dags-image">
      <img src="@/assets/dags/dags3.jpg" alt="Dags 3" class="dags-image">
    </div>
  </div>
</template>
<script>
export default {
    name: "DagsPage",
}
</script>
<style lang="scss" scoped>
.dags-container {
  padding: 40px;
  min-width: 1200px; 
    width: 1200px; 
  .text-title {
    color: #f018aa;
    text-align: center;
    margin-bottom: 30px;
  }

  .image-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    .dags-image {
      width: 80%;
      max-width: 600px;
      height: auto;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
  }
}
</style>